/**
 * Created by Olexiy on 23.03.2017.
 */

/**
 * author Christopher Blum
 *    - based on the idea of Remy Sharp, http://remysharp.com/2009/01/26/element-in-view-event-plugin/
 *    - forked from http://github.com/zuk/jquery.inview/
 */
(function (factory) {
  if (typeof define == 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  } else {
    factory(jQuery);
  }
}(function ($) {
  var inviewObjects = [], viewportSize, viewportOffset,
      d = document, w = window, documentElement = d.documentElement, timer;

  $.event.special.inview = {
    add: function(data) {
      inviewObjects.push({ data: data, $element: $(this), element: this });
      if (!timer && inviewObjects.length) {
         timer = setInterval(checkInView, 250);
      }
    },
    remove: function(data) {
      for (var i=0; i<inviewObjects.length; i++) {
        var inviewObject = inviewObjects[i];
        if (inviewObject.element === this && inviewObject.data.guid === data.guid) {
          inviewObjects.splice(i, 1);
          break;
        }
      }

      if (!inviewObjects.length) {
         clearInterval(timer);
         timer = null;
      }
    }
  };

  function getViewportSize() {
    var mode, domObject, size = { height: w.innerHeight, width: w.innerWidth };

    if (!size.height) {
      mode = d.compatMode;
      if (mode || !$.support.boxModel) {
        domObject = mode === 'CSS1Compat' ?
          documentElement :
          d.body;
        size = {
          height: domObject.clientHeight,
          width:  domObject.clientWidth
        };
      }
    }

    return size;
  }

  function getViewportOffset() {
    return {
      top:  w.pageYOffset || documentElement.scrollTop   || d.body.scrollTop,
      left: w.pageXOffset || documentElement.scrollLeft  || d.body.scrollLeft
    };
  }

  function checkInView() {
    if (!inviewObjects.length) {
      return;
    }

    var i = 0, $elements = $.map(inviewObjects, function(inviewObject) {
      var selector  = inviewObject.data.selector,
          $element  = inviewObject.$element;
      return selector ? $element.find(selector) : $element;
    });

    viewportSize   = viewportSize   || getViewportSize();
    viewportOffset = viewportOffset || getViewportOffset();

    for (; i<inviewObjects.length; i++) {
      if (!$.contains(documentElement, $elements[i][0])) {
        continue;
      }

      var $element      = $($elements[i]),
          elementSize   = { height: $element[0].offsetHeight, width: $element[0].offsetWidth },
          elementOffset = $element.offset(),
          inView        = $element.data('inview');

      if (!viewportOffset || !viewportSize) {
        return;
      }

      if (elementOffset.top + elementSize.height > viewportOffset.top &&
          elementOffset.top < viewportOffset.top + viewportSize.height &&
          elementOffset.left + elementSize.width > viewportOffset.left &&
          elementOffset.left < viewportOffset.left + viewportSize.width) {
        if (!inView) {
          $element.data('inview', true).trigger('inview', [true]);
        }
      } else if (inView) {
        $element.data('inview', false).trigger('inview', [false]);
      }
    }
  }

  $(w).on("scroll resize scrollstop", function() {
    viewportSize = viewportOffset = null;
  });

  if (!documentElement.addEventListener && documentElement.attachEvent) {
    documentElement.attachEvent("onfocusin", function() {
      viewportOffset = null;
    });
  }
}));

// JS for agency News category template and agency post template

(function($){
  $(document).ready(function() {

    // only load youtube api etc. on agancy post
    if($('.wrap').attr('id') !== 'agency-post') {
      return;
    }

    /**
     * Main video.
     */

    if($('#main-video').length) {
      var $mainVideo = $('#main-video');
      $('.main-header').append($mainVideo.clone().removeClass('hidden'))
        .addClass('agency-video-container');

      $mainVideo.remove();
    }

    /**
     * YouTube integration.
     */

    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    var player = null;

    function onPlayerStateChange(evt) {
      if (evt.data === YT.PlayerState.ENDED) {
        $('.agency-video-btn__content--active').removeClass('agency-video-btn__content--active');
      }
    }

    function onPlayerReady() {
      player.playVideo();
    }

    function closeVideoOverlay() {
      if(player) {
        player.destroy();
      }

      $('.video-overlay').removeClass('video-overlay--active');
    }

    function onVideoBtnClick(evt) {
      $('.video-overlay__content__inner').append('<div class="player" id="player" />');
      player = new YT.Player($('#player')[0], {
        height: '390',
        width: '640',
        videoId: $(this).data('youtube-id'),
        events: {
          'onStateChange': onPlayerStateChange,
          'onReady': onPlayerReady
        }
      });

      $('.video-overlay').addClass('video-overlay--active');
      return false;
    }

    function onVideoOverLayClick(evt) {
      closeVideoOverlay();
      return false;
    }

    function onVideoContainerClick(evt) {
      $('.agency-video-btn', this).click();
    }

    // needs to be global
    window.onYouTubeIframeAPIReady = function() {
      $('.agency-video-btn').on('click', onVideoBtnClick);
      $('.video-overlay').on('click', onVideoOverLayClick);
      $('.agency-video-container').on('click', onVideoContainerClick);
    };

    /**
     * Reveal animations.
     */

     $('.reveal').on('inview', function(evt, isInView) {
      if (isInView) {
        $(this).addClass('in-view');
      }
    });
  });
})(jQuery);
